import React from 'react';
import { OFFER_ANCHOR } from './constants';
const bonuses = [{
  title: '🎁 BONUS 1 — Professional Installation Checklists™',
  description: 'Complete step-by-step checklists covering every stage of a Smart Home installation, from planning to final client delivery.'
}, {
  title: '🎁 BONUS 2 — Smart Home Wiring & Diagram Guide™',
  description: 'Professional wiring diagrams, installation layouts, connection examples, and visual references for the most common Smart Home devices.'
}, {
  title: '🎁 BONUS 3 — Professional Project Templates™',
  description: 'Client questionnaires, project planners, equipment lists, installation reports, documentation templates, and handover forms ready to customize.'
}, {
  title: '🎁 BONUS 4 — Troubleshooting & Diagnostic Handbook™',
  description: 'A practical guide for identifying, diagnosing, and solving the most common installation and configuration problems.'
}, {
  title: '🎁 BONUS 5 — Smart Home Business Starter Kit™',
  description: 'Quotation templates, pricing worksheets, service packages, marketing ideas, portfolio examples, and client management resources.'
}];
export function BonusSection() {
  return <section className="border-y border-brand-line bg-brand-light px-4 py-5" data-id="element-16" data-mp="2jio83lyk3u3l">
      <div className="mx-auto max-w-4xl" data-id="element-17" data-mp="2ofo577dfhmik">
        <div className="mb-3 text-center" data-id="element-18" data-mp="2oitwmt9j50hg">
          <h2 className="mb-1 font-display text-xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-19" data-mp="1quabnan495u5">
            🎁 5 Premium Bonuses Included
          </h2>
          <p className="mx-auto max-w-3xl text-sm font-normal leading-snug text-brand-muted sm:text-base" data-id="element-20" data-mp="20reoukyzhqyt">
            Your enrollment also includes five professional bonuses designed to help you install
            faster, work more efficiently, and start your Smart Home business with confidence.
          </p>
        </div>
        <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-21" data-mp="3h4ve90aidui2">
          {bonuses.map(bonus => <a key={bonus.title} href={OFFER_ANCHOR} className="cursor-pointer rounded-xl border border-brand-amber/60 bg-white p-3 shadow-sm transition-all hover:border-brand-orange hover:shadow-md" data-id="element-22" data-mp="1h2vrwtl5bn1n">
              <h3 className="font-display text-[13px] font-bold leading-tight text-brand-ink sm:text-base" data-id="element-23" data-mp="1q1zck1zyoai9">
                {bonus.title}
              </h3>
              <p className="mt-0.5 text-xs font-normal leading-snug text-brand-muted sm:text-sm" data-id="element-24" data-mp="ydyzywd816ml">
                {bonus.description}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}